import { Search, MessageCircle, KeyRound } from "lucide-react";
import { Reveal, Overline } from "./ui";

const steps = [
  {
    n: "1",
    icon: Search,
    title: "Browse & Select",
    desc: "Explore our fleet of cars and bikes above and pick the ride that fits your plans.",
  },
  {
    n: "2",
    icon: MessageCircle,
    title: "Get in Touch",
    desc: "Chat with us on WhatsApp or call directly to confirm availability for your dates.",
  },
  {
    n: "3",
    icon: KeyRound,
    title: "Pick Up & Drive",
    desc: "Submit your documents, pay the security deposit, grab the keys and hit the road.",
  },
];

export default function Process() {
  return (
    <section className="relative overflow-hidden bg-ink px-5 py-24 md:px-10 md:py-32">
      <div className="mx-auto max-w-[1400px]">
        <Reveal className="mb-16 max-w-2xl">
          <Overline>How It Works</Overline>
          <h2 className="mt-4 font-heading text-3xl font-bold uppercase tracking-tight text-white sm:text-4xl md:text-5xl">
            Three steps to the open road
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 gap-px border border-white/10 bg-white/10 md:grid-cols-3">
          {steps.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.12}>
              <div className="group relative h-full overflow-hidden bg-ink p-8 md:p-10">
                <span className="pointer-events-none absolute -right-2 -top-8 select-none font-serif-ed text-[9rem] font-light italic leading-none text-white/[0.04] transition-colors duration-500 group-hover:text-volt/10 md:text-[12rem]">
                  {s.n}
                </span>
                <div className="relative">
                  <div className="flex h-12 w-12 items-center justify-center border border-volt/40 text-volt">
                    <s.icon size={20} />
                  </div>
                  <h3 className="mt-6 font-heading text-2xl font-bold uppercase tracking-tight text-white">
                    {s.title}
                  </h3>
                  <p className="mt-3 max-w-xs text-sm leading-relaxed text-white/60">{s.desc}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
